import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "terms-and-conditions"
}
const _hoisted_2 = ["href"]

import { computed } from 'vue'
  import { useStore } from 'vuex'
  import localeToConditionsUrl from '@/config/termsAndConditions'
  import yoonlyDomainToConditionsUrl from '@/config/termsAndConditions'
  import YoonlyService from '@/services/YoonlyService'

  // Define the props
  
export default /*@__PURE__*/_defineComponent({
  __name: 'TermsAndConditionsLink',
  props: {
    linkText: {},
    customUrl: {}
  },
  setup(__props: any) {

  const props = __props

  const store = useStore()
  const isYoonly = new YoonlyService().isYoonly

  // Get current locale from store
  const currentLocale = computed(() => {
    const locale = store.getters.getLocale || 'en-US'

    // Convert from hyphen format (fr-FR) to underscore format (fr_FR)
    const underscoreLocale = locale.replace(/-/g, '_')
    return underscoreLocale
  })

  // Get the terms and conditions URL for current locale, or use custom URL if provided
  const termsUrl = computed(() => {
    if (isYoonly) {
      return yoonlyDomainToConditionsUrl[window.location.hostname] || yoonlyDomainToConditionsUrl['www.yoonly.eu']
    }

    if (props.customUrl) {
      return props.customUrl
    }

    return localeToConditionsUrl[currentLocale.value] || localeToConditionsUrl['en_US']
  })

return (_ctx: any,_cache: any) => {
  return (termsUrl.value)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createElementVNode("a", {
          href: termsUrl.value,
          target: "_blank",
          rel: "noopener noreferrer",
          class: "terms-link"
        }, _toDisplayString(_ctx.linkText), 9, _hoisted_2)
      ]))
    : _createCommentVNode("", true)
}
}

})